var SHOP_ADVANTAGES = (function () {

    function initYoutubeLinks() {
        var videoButton = $(".property-video-link");

        if (!videoButton.length) {
            return false;
        }

        videoButton.on("click", function openVideo(e) {
            var videoLink = $(e.target).data("href");
            $.fancybox({
                padding: 0,
                autoScale: false,
                transitionIn: 'none',
                transitionOut: 'none',
                href: videoLink,
                type: 'iframe'
            });
        });
    }

    return {
        initYoutubeLinks: initYoutubeLinks
    }
})(jQuery);

$(document).ready(function () {
    SHOP_ADVANTAGES.initYoutubeLinks();
});